(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@platform/card-table/index"] = factory();
	else
		root["@platform/card-table/index"] = factory();
})(window, function() {
return 